var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5511 17.0175C22.5675 15.791 22.9053 14.5884 23.5333 13.5216C24.1612 12.4548 25.0588 11.5585 26.1425 10.916C25.454 9.96796 24.5458 9.18774 23.4899 8.63733C22.4341 8.08693 21.2597 7.7815 20.06 7.7453C17.5008 7.48628 15.0198 9.22191 13.7157 9.22191C12.3863 9.22191 10.3785 7.77102 8.21632 7.81391C6.81778 7.85748 5.4548 8.24962 4.26017 8.95213C3.06554 9.65464 2.08001 10.6436 1.39959 11.8225C-1.54775 16.7431 0.650707 23.9746 3.47407 27.952C4.88666 29.8996 6.53757 32.0751 8.69777 31.998C10.8117 31.9135 11.6011 30.6982 14.1528 30.6982C16.6807 30.6982 17.4214 31.998 19.6255 31.949C21.8938 31.9135 23.3229 29.9927 24.6859 28.0266C25.7009 26.6389 26.4819 25.1051 27 23.4822C25.6822 22.9447 24.5576 22.0451 23.7664 20.8955C22.9753 19.7459 22.5526 18.3972 22.5511 17.0175Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.388 5.12951C19.6248 3.6979 20.2341 1.85781 20.0866 0C18.1971 0.191359 16.4517 1.06213 15.1982 2.43881C14.5854 3.11135 14.116 3.89377 13.8169 4.74134C13.5178 5.58891 13.3949 6.48501 13.4552 7.3784C14.4003 7.38778 15.3353 7.19026 16.1897 6.80072C17.0442 6.41117 17.7958 5.83976 18.388 5.12951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.dead69ef8723fd3a5f8b1dc0724767f7.svg";
export { ForwardRef as ReactComponent };